export const clearCacheAndReloadApplication = () => {
	// caches ? caches.keys().then((keys) => keys.forEach(t => caches.delete(t))) : {};
	window.location.reload(true);
};
